import { CFOP } from '@modules/cfops/types/cfops'
import { FindCfopRequest } from '@modules/cfops/types/requests'
import { AxiosInstance } from 'axios'

export class CFOPService {
  private instance: AxiosInstance

  constructor(instance: AxiosInstance) {
    this.instance = instance
  }

  async find(params: FindCfopRequest): Promise<CFOP[]> {
    const response = await this.instance.get(`/invoices/cfops`, { params })

    return response.data
  }
}

export const cfopsService = (instance: AxiosInstance) => new CFOPService(instance)
